import { createMulticall } from '@tech-alchemy/best-dex/redux-multicall'

// Create a multicall instance with default settings
export const multicall = createMulticall()
